module.exports = __webpack_public_path__ + "1ee3b798d0e8245287a0f0c820abc433.svg";